import statesTemplate from './states.html';

export default angular
  .module('main.locations.edit.tabs.states', [])

  .directive('editLocationStatesTab', () => {
    return {
      restrict: 'E',
      template: statesTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   utils,
                   EditLocationDataProvider) => {
        $scope.dataProvider = EditLocationDataProvider.instance;

        angular.extend($scope, {
          onBackButtonClick: onBackButtonClick,
        });

        init();

        function init() {
          $scope.init = false;
          $q.all([
            $scope.dataProvider.locationResource.init()
          ])
            .then(() => {
              $scope.init = true;
            }, (err) => {
              // utils.handleApiError(err);
            });
        }

        function onBackButtonClick() {
          $scope.dataProvider.activeTab = 'settings';
        }
      }
    };
  })
  .name;
